import { Flex, Button } from "antd";

import ImageIcon from "@/icons/ImageIcon";
import FilmIcon from "@/icons/FilmIcon";
import FileIcon from "@/icons/FileIcon";
import ZipIcon from "@/icons/ZipIcon";
import FileTextIcon from "@/icons/FileTextIcon";
import FilePdfIcon from "@/icons/FilePdfIcon";
import FileExcelIcon from "@/icons/FileExcelIcon";
import DownloadIcon from "@/icons/DownloadIcon";

import ImageWithPreview from "@/components/ui/ImageWithPreview";

import ExclamationIcon from "@/icons/ExclamationIcon";

const getIconByType = (type, extension, color) => {
  switch (type) {
    case "image":
      return <ImageIcon style={{ color, fontSize: "16px" }} />;
    case "video":
      return <FilmIcon style={{ color, fontSize: "16px" }} />;

    case "application":
      switch (extension) {
        case "zip":
          return <ZipIcon style={{ color, fontSize: "16px" }} />;
        case "docx":
          return <FileTextIcon style={{ color, fontSize: "16px" }} />;
        case "pdf":
          return <FilePdfIcon style={{ color, fontSize: "16px" }} />;
        case "xlsx":
          return <FileExcelIcon style={{ color, fontSize: "16px" }} />;
        default:
          return <FileIcon style={{ color, fontSize: "16px" }} />;
      }

    default:
      return <FileIcon style={{ color, fontSize: "16px" }} />;
  }
};

const FileField = ({ value, miniature = false, btnClick = null, hideBtn }) => {
  const { original_name, type, extension, uuid, name, missing } = value || {};
  return missing ? (
    <Flex align="center" gap={5}>
      <ExclamationIcon
        style={{
          color: "var(--color-secondary)",
          fontSize: "22px",
        }}
      />
      <span>Файл удален</span>
    </Flex>
  ) : original_name ? (
    type === "image" && !btnClick ? (
      <ImageWithPreview
        uuid={uuid}
        original_name={name}
        name={name}
        extension={extension}
      />
    ) : (
      <Flex align="center" gap={5}>
        {getIconByType(
          type,
          extension,
          btnClick ? "var(--color-primary)" : "var(--color-secondary)",
        )}
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1,
          }}
        >
          {original_name}
        </div>
        {!hideBtn ? (
          btnClick ? (
            <Button
              size="small"
              onClick={btnClick}
              style={{ marginLeft: "auto" }}
            >
              Смотреть
            </Button>
          ) : (
            !miniature && (
              <a
                href={`/api/file/download?uuid=${uuid}`}
                download={original_name}
                style={{ fontSize: "16px" }}
              >
                <DownloadIcon
                  style={{
                    color: "var(--color-secondary)",
                    fontSize: "16px",
                  }}
                />
              </a>
            )
          )
        ) : null}
      </Flex>
    )
  ) : (
    ""
  );
};
export default FileField;
